import React from 'react'
import { Box, Typography, Button } from '@mui/material'
import { styled, keyframes } from '@mui/material/styles'
import { ChatBubbleOutline, EmojiEmotions, Lightbulb } from '@mui/icons-material'

const float = keyframes`
  0%, 100% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-10px) rotate(2deg); }
`

const pulse = keyframes`
  0%, 100% { opacity: 0.8; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.05); }
`

const EmptyStateContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '48px 24px',
  textAlign: 'center',
  minHeight: '200px',
})

const IconContainer = styled(Box)({
  marginBottom: '16px',
})

const MainIcon = styled(Box)({
  width: '48px',
  height: '48px',
  borderRadius: '50%',
  backgroundColor: '#f3f4f6',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '0 auto',

  '& svg': {
    fontSize: '24px',
    color: '#9ca3af',
  },
})

const Title = styled(Typography)({
  fontSize: '16px',
  fontWeight: 600,
  color: '#111827',
  marginBottom: '4px',
})

const Subtitle = styled(Typography)({
  fontSize: '14px',
  fontWeight: 400,
  color: '#6b7280',
  lineHeight: 1.4,
  maxWidth: '300px',
})

interface ModernCommentsEmptyStateProps {
  title?: string
  subtitle?: string
  showSuggestions?: boolean
  onStartConversation?: () => void
}

export function ModernCommentsEmptyState({
  title = 'No comments yet',
  subtitle = 'Be the first to share your thoughts.',
}: ModernCommentsEmptyStateProps) {
  return (
    <EmptyStateContainer>
      <IconContainer>
        <MainIcon>
          <ChatBubbleOutline />
        </MainIcon>
      </IconContainer>

      <Title>{title}</Title>
      <Subtitle>{subtitle}</Subtitle>
    </EmptyStateContainer>
  )
}
